export default "__VITE_ASSET__B6vTUNUa__"